import styled from 'styled-components';

export const FooterContainer = styled.footer`
    position: relative;
    z-index: 5;
    
    background: linear-gradient(150deg, var(--color-primary), var(--color-tertiary), var(--color-secondary));
    background: #f5f5f5;

    overflow: hidden;

    > .content {
        min-height: 50vh;

        padding: 20rem 0 5rem;

        .grid-footer {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1.5fr;
            padding-bottom: 7rem;

            .box-footer {
                width: 100%;

                h2 {
                    font-size: 2rem;
                    margin-bottom: 3rem;
                }

                ul {
                    list-style: none;
                    li {
                        & + li {
                            margin-top: 1rem;
                        }

                        a {
                            font-size: 1.6rem;
                            transition: .1s;
                            &:hover {
                                color: var(--color-primary);
                                font-weight: 500;
                                // text-decoration: underline;
                            }
                        }
                    }
                }
            }
            
            .brand {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: center;
                text-align: right;

                img {
                    width: 17rem;
                    filter: grayscale(1);
                    margin-bottom: 20px;
                }

                p {
                    font-size: 2rem;
                    font-weight: 300;
                    line-height: 160%;
                }
            }
        }
    }

    .footer-bottom {
        width: 100%;
        min-height: 15rem;
        border-top: 1px solid #ddd;
        padding: 10rem 0;
        
        background: linear-gradient(150deg, var(--color-primary), var(--color-tertiary), var(--color-secondary));
        color: #fff;
        
        .content {
            display: flex;
            align-items: center;
            justify-content: space-between;
        
            .copyright {
                display: flex;
                flex-direction: column;
                img {
                    width: 12rem;
                    margin-bottom: 1.5rem;
                }
                span {
                    font-size: 1.8rem;
                    font-weight: 300;
                    letter-spacing: 0.05rem;
                    & + span {
                        margin-top: 7px;
                    }
                }
            }

            .social {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                text-align: right;
                
                h3 {
                    font-size: 2.2rem;
                    margin-bottom: 2rem;
                    color: var(--color-white);
                }
                .social-links {
                    display: flex;
                    a {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 2.2rem;
                        transition: .2s;
                        & + a {
                            margin-left: 1.5rem;
                        }
                        i {
                            transition: .2s;
                        }
                        &:hover i {
                            color: var(--color-secondary);
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 540px) {

        > .content {
            .grid-footer {
                display: flex;
                flex-direction: column-reverse;
                align-items: center;
                text-align: center;

                .box-footer, .brand {
                    text-align: center;
                    margin-bottom: 11.11111vw;
                }

                .box-footer {
                    h2 {
                        font-size: 3.88889vw;
                    }

                    ul {
                        li {
                            a {
                                font-size: 3.05556vw;  
                            }
                        }
                    }
                }

                .brand {
                    align-items: center;
                    justify-content: unset;

                    img {
                        width: 30.55556vw;
                        margin-bottom: 4.16667vw;
                    }

                    p {
                        font-size: 4.16667vw;
                    }
                }
            }
        }

        .footer-bottom {
            .content {
                flex-direction: column;
                text-align: center;
                justify-content: unset;

                .copyright, .social {
                    align-items: center;
                    justify-content: unset;
                    text-align: center;
                }

                .copyright {
                    margin-bottom: 5.55556vw;
                    padding-bottom: 5.55556vw;

                    border-bottom: 0.27778vw solid #fff;
                }
            }
        }
    }
`;
